import { useEffect, useState } from "react";
import { COOKIE_NAMES, getCookie } from "utils/cookie";

// 리다이렉트할 서브도메인으로 보지 않는 workspace eid
const IGNORE_EIDS = ["proposal-generator"];

export default function useAutoLogIn(): boolean {
  const [shouldLogIn, setShouldLogIn] = useState(true);

  const redirectToLoggedInWorkspace = () => {
    const workspaceEids = JSON.parse(
      getCookie(COOKIE_NAMES.WORKSPACE_EIDS) || "[]",
    );
    const latestWorkspaceEid = getCookie(COOKIE_NAMES.LATEST_WORKSPACE);
    const latestProjectId = getCookie(
      COOKIE_NAMES.LATEST_PROJECT_ID_FOR_PROJECT_USER,
    );
    const { location } = window;
    if (
      workspaceEids.length > 0 &&
      location.hostname !== "localhost" &&
      location.pathname === "/"
    ) {
      if (latestWorkspaceEid) {
        if (IGNORE_EIDS.includes(latestWorkspaceEid)) return;
        if (latestProjectId) {
          location.href = `https://${latestWorkspaceEid}.${location.hostname}/project/${latestProjectId}`;
        } else {
          location.href = `https://${latestWorkspaceEid}.${location.hostname}`;
        }
      } else {
        location.href = `https://${workspaceEids[0]}.${location.hostname}`;
      }
    } else {
      setShouldLogIn(false);
    }
  };

  useEffect(() => {
    redirectToLoggedInWorkspace();
  }, []);

  return shouldLogIn;
}
